/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC, useEffect, useState} from 'react'
import {FormProvider, useForm} from 'react-hook-form'
import {KTCard, isNotEmpty} from '../../../../../../../_metronic/helpers'
import {Button, ButtonWrapper} from '../../../../../components/UI/Button'
import {
  SelectAsyncWrapper,
  SelectWrapper,
  InputDateWrapper,
} from '../../../../../components/UI/Form/Input'
import {SelectOption} from '../../../../../models/utility.model'
import {useCentralServices} from '../../../hooks/useCentralServices'
import {Occupancy2ReportDTO} from '../../../models/reports.model'
import {yupResolver} from '@hookform/resolvers/yup'
import {reportOccupancy2Schema} from '../../../../../util/validationHoteleria'
import {
  getFilterGuestOccupancyReportDTableList,
  getFilterEnterpriseOccupancyReportDTableList,
  getFilterModuleOccupancyReportDTableList,
  getFilterRoomOccupancyReportDTableList,
  getFilterBedOccupancyReportDTableList,
} from '../../../services/report.service'
import {getRatioRoomingListExcelService} from '../../../services/ratio.service'
import {TableReportOccupancy2} from './Tables/TableReportOccupancy2'
import {TotalComponent} from './dragContent'
import {getSnackBarToast} from '../../../../../util/snackBar'
import moment from 'moment'
const ReportOccupancy2: FC = () => {
  const methods = useForm<any>({
    resolver: yupResolver(reportOccupancy2Schema),
    defaultValues: {
      CompaniaId: '',
      ClienteId: '',
      SiteId: '',
      CampamentoId: '',
    },
  })

  const [isDownloadXLS, setIsDownloadXLS] = useState<boolean>(false)
  const {setValue, handleSubmit, setError, reset, watch} = methods
  const [searching, setSearching] = useState(false)
  const [isReset, setIsReset] = useState(false)
  const [valueForm, setValueForm] = useState<Occupancy2ReportDTO>({})
  const [company, setCompany] = useState<SelectOption[]>([])
  const [client, setClient] = useState<SelectOption[]>([])
  const [sites, setSites] = useState<SelectOption[]>([])
  const [camps, setCamps] = useState<SelectOption[]>([])
  const [dataGroup, setDataGroup] = useState<any>([])
  const [show, setShow] = useState<any>(false)
  const {getCompanies, getClients, getSites, getCamps} = useCentralServices()

  const getCompaniesFn = async () => {
    const data = await getCompanies({isCombo: true}, 1)
    if (data.length === 1) {
      setValue('CompaniaId', data[0].value as string)
      setError('CompaniaId', {})
      await getClientsFn(data[0].value as string)
    }
    setCompany(data)
  }
  const getClientsFn = async (companyId: string) => {
    const data = await getClients({isCombo: true, companiaId: companyId}, 1)
    if (data.length === 1) {
      setValue('ClienteId', data[0].value as string)
      setError('ClienteId', {})
      await getSitesFn(data[0].value as string)
    }
    setClient(data)
  }
  const getSitesFn = async (clientId: string) => {
    const data = await getSites({isCombo: true, clienteId: clientId}, 1)
    if (data.length === 1) {
      setValue('SiteId', data[0].value as string)
      setError('SiteId', {})
      await getCampsFn(data[0].value as string)
    }
    setSites(data)
  }
  const getCampsFn = async (siteId: string) => {
    const data = await getCamps({isCombo: true, siteId: siteId}, 1)
    if (data.length === 1) {
      setValue('CampamentoId', data[0].value as string)
      setError('CampamentoId', {})
    }
    const allData = [{value: '4EsB2NAAsDA=', label: 'TODOS'}, ...data]
    setCamps(allData)
  }
  const handleCompanyChange = (val: any) => {
    let value = val ? val.value : ''
    setValue('CompaniaId', value)
    setValue('ClienteId', '')
    setValue('SiteId', '')
    setSites([])
    setValue('CampamentoId', '')
    setCamps([])
    setError('CompaniaId', {})
    getClientsFn(value)
  }
  const handleClientChange = (val: any) => {
    let value = val ? val.value : ''
    setValue('ClienteId', value)
    setValue('SiteId', '')
    setValue('CampamentoId', '')
    setCamps([])
    setError('ClienteId', {})
    getSitesFn(value)
  }
  const handleSiteChange = (val: any) => {
    let value = val ? val.value : ''
    setValue('SiteId', value)
    setValue('CampamentoId', '')
    setError('SiteId', {})
    getCampsFn(value)
  }
  const handleClear = () => {
    reset()
    setClient([])
    setSites([])
    setCamps([])
    setValue('nroDiaFin', '')
    setDataGroup([])
    setValueForm({})
    getCompaniesFn()
    setIsReset(true)
  }
  const loadOptionsGuest = async (inputValue: string, callback: (options: any[]) => void) => {
    try {
      if (inputValue.length < 3) {
        return []
      }
      const {data: response} = await getFilterGuestOccupancyReportDTableList({
        FechaInicio: watch('nroDiaFin') || '',
        SiteId: watch('SiteId') || null,
        CampamentoId: watch('CampamentoId') || null,
        BuscaTexto: inputValue,
      })
      if (response.length > 0) {
        const mappedGuests = response?.map((guest: any) => ({
          value: guest.HuespedId,
          label: `${guest.HuespedNombres} ${guest.HuespedApPaterno} ${guest.HuespedApMaterno} ${guest.HuespedNroDoc}`,
          ...guest,
        }))
        return mappedGuests
      } else {
        return []
      }
    } catch (error) {
      console.error('Error fetching options:', error)
      return []
    }
  }
  const loadOptionsEnterprise = async (inputValue: string, callback: (options: any[]) => void) => {
    try {
      if (inputValue.length < 3) {
        return []
      }
      const {data: response} = await getFilterEnterpriseOccupancyReportDTableList({
        FechaInicio: watch('nroDiaFin') || '',
        SiteId: watch('SiteId') || null,
        CampamentoId: watch('CampamentoId') || null,
        BuscaTexto: inputValue,
      })
      if (response.length > 0) {
        const mappedGuests = response?.map((guest: any) => ({
          value: guest.EmpresaId,
          label: `${guest.RucEmpresa} ${guest.RazonSocialEmpresa}`,

          ...guest,
        }))
        return mappedGuests
      } else {
        return []
      }
    } catch (error) {
      console.error('Error fetching options:', error)
      return []
    }
  }
  const loadOptionsModule = async (inputValue: string, callback: (options: any[]) => void) => {
    try {
      const {data: response} = await getFilterModuleOccupancyReportDTableList({
        FechaInicio: watch('nroDiaFin') || '',
        SiteId: watch('SiteId') || null,
        CampamentoId: watch('CampamentoId') || null,
        BuscaTexto: inputValue,
      })
      if (response.length > 0) {
        const mappedGuests = response?.map((guest: any) => ({
          value: guest.ModuloId,
          label: guest.Codigo,
          ...guest,
        }))
        return mappedGuests
      } else {
        return []
      }
    } catch (error) {
      console.error('Error fetching options:', error)
      return []
    }
  }
  const loadOptionsRoom = async (inputValue: string, callback: (options: any[]) => void) => {
    try {
      if (!isNotEmpty(watch('ModuloId'))) {
        return []
      }
      const {data: response} = await getFilterRoomOccupancyReportDTableList({
        FechaInicio: watch('nroDiaFin') || '',
        SiteId: watch('SiteId') || null,
        CampamentoId: watch('CampamentoId') || null,
        ModuloDetId: watch('ModuloId'),
        BuscaTexto: inputValue,
      })
      if (response.length > 0) {
        const mappedGuests = response?.map((guest: any) => ({
          value: guest.HabitacionId,
          label: guest.Codigo,
          ...guest,
        }))
        return mappedGuests
      } else {
        return []
      }
    } catch (error) {
      console.error('Error fetching options:', error)
      return []
    }
  }
  const loadOptionsBed = async (inputValue: string, callback: (options: any[]) => void) => {
    try {
      if (!isNotEmpty(watch('HabitacionId'))) {
        return []
      }
      const {data: response} = await getFilterBedOccupancyReportDTableList({
        FechaInicio: watch('nroDiaFin') || '',
        SiteId: watch('SiteId') || null,
        CampamentoId: watch('CampamentoId') || null,
        HabitacionDetId: watch('HabitacionId'),
        BuscaTexto: inputValue,
      })
      if (response.length > 0) {
        const mappedGuests = response?.map((guest: any) => ({
          value: guest.CamaId,
          label: guest.Codigo,
          ...guest,
        }))
        return mappedGuests
      } else {
        return []
      }
    } catch (error) {
      console.error('Error fetching options:', error)
      return []
    }
  }
  const onSubmit = async (dataForm: Occupancy2ReportDTO) => {
    setValueForm(dataForm)
    setSearching(true)
    setShow(true)
  }
  const getInformationColaborador = async (e: any) => {
    let value = e ? e : ''
    setValue('HuespedDetId', value.value)
    setValue('Huesped_descripcion', value.label)
  }
  const getInformationEnterprise = async (e: any) => {
    let value = e ? e : ''
    setValue('EmpresaId', value.value)
    setValue('EmpresaNombre', value.label)
  }
  const getInformationModule = async (e: any) => {
    let value = e ? e : ''
    setValue('ModuloId', value.value)
    setValue('ModuloCodigo', value.label)
    setValue('HabitacionId', null)
    setValue('HabitacionCodigo', null)
    setValue('CamaId', null)
    setValue('CamaCodigo', null)
  }
  const getInformationRoom = async (e: any) => {
    let value = e ? e : ''
    setValue('HabitacionId', value.value)
    setValue('HabitacionCodigo', value.label)
    setValue('CamaId', '')
    setValue('CamaCodigo', '')
  }
  const getInformationBed = async (e: any) => {
    let value = e ? e : ''
    setValue('CamaId', value.value)
    setValue('CamaCodigo', value.label)
  }

  useEffect(() => {
    getCompaniesFn()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    setShow(false)
  }, [dataGroup])

  const handleExportXLS = async () => {
    try {
      setIsDownloadXLS(true)

      const obj = {
        pageNumber: 1,
        size: 10,
        CompaniaId: watch('CompaniaId'),
        ClienteId: watch('ClienteId'),
        SiteId: watch('SiteId'),
        CampamentoId: null,
        ModuloId: null,
        Fecha: watch('nroDiaFin'),
      }
      const response = await getRatioRoomingListExcelService(obj)
      const blob = new Blob([response.data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      })
      moment().format('DD/MM/YY HH:mm').toString()
      const link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = `Reporte de Facturacion-${moment().format('DD/MM/YY HH:mm').toString()}.xlsx` // Ajusta el nombre del archivo según tus necesidades
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      setIsDownloadXLS(false)
      getSnackBarToast('Se descargó el documento con éxito', 'success')
    } catch (error) {
      setIsDownloadXLS(false)
      getSnackBarToast('Hubo un error al descargar', 'error')
    }
  }
  return (
    <>
      <KTCard shadow className='m-5'>
        <div className='p-6'>
          <FormProvider {...methods}>
            <form className='m-2'>
              <div className='row'>
                <div className='col-sm-12 col-lg-3'>
                  <SelectWrapper
                    labelText='Compañia'
                    name='CompaniaId'
                    data={company}
                    onChangeValue={handleCompanyChange}
                    required
                  />
                </div>
                <div className='col-sm-12 col-lg-3'>
                  <SelectWrapper
                    labelText='Cliente'
                    name='ClienteId'
                    data={client}
                    onChangeValue={handleClientChange}
                    required
                  />
                </div>
                <div className='col-sm-12 col-lg-3'>
                  <SelectWrapper
                    labelText='Site'
                    name='SiteId'
                    data={sites}
                    onChangeValue={handleSiteChange}
                    required
                  />
                </div>
                <div className='col-sm-12 col-lg-3'>
                  <SelectWrapper labelText='Campamento' name='CampamentoId' data={camps} required />
                </div>
              </div>
              <div className='row'>
                <div className='col-sm-12 col-lg-3'>
                  <InputDateWrapper labelText='Periodo' name='nroDiaFin' required />
                </div>
                {watch('nroDiaFin') && watch('CampamentoId') && (
                  <>
                    <div className='col-sm-12 col-lg-3'>
                      <SelectAsyncWrapper
                        labelText='Datos del Huésped'
                        keySelect={`${watch('nroDiaFin')}-${watch('CampamentoId')}`}
                        name='HuespedDetId'
                        loadOptions={loadOptionsGuest}
                        onChangeValue={getInformationColaborador}
                        value={{
                          value: watch('HuespedDetId') || '',
                          label: watch('Huesped_descripcion') || '',
                        }}
                      />
                    </div>
                    <div className='col-sm-12 col-lg-3'>
                      <SelectAsyncWrapper
                        labelText='Datos de la empresa'
                        keySelect={`${watch('nroDiaFin')}-${watch('CampamentoId')}`}
                        name='EmpresaId'
                        loadOptions={loadOptionsEnterprise}
                        onChangeValue={getInformationEnterprise}
                        value={{
                          value: watch('EmpresaId') || '',
                          label: watch('EmpresaNombre') || '',
                        }}
                      />
                    </div>
                    <div className='col-sm-12 col-lg-3'>
                      <SelectAsyncWrapper
                        labelText='Modulo'
                        keySelect={`${watch('nroDiaFin')}-${watch('CampamentoId')}`}
                        name='ModuloId'
                        loadOptions={loadOptionsModule}
                        onChangeValue={getInformationModule}
                        value={{
                          value: watch('ModuloId') || '',
                          label: watch('ModuloCodigo') || '',
                        }}
                      />
                    </div>
                    <div className='col-sm-12 col-lg-3'>
                      <SelectAsyncWrapper
                        labelText='Habitación'
                        keySelect={`${watch('nroDiaFin')}-${watch('CampamentoId')}-${watch(
                          'ModuloId',
                        )}`}
                        name='HabitacionId'
                        loadOptions={loadOptionsRoom}
                        onChangeValue={getInformationRoom}
                        value={{
                          value: watch('HabitacionId') || '',
                          label: watch('HabitacionCodigo') || '',
                        }}
                      />
                    </div>
                    <div className='col-sm-12 col-lg-3'>
                      <SelectAsyncWrapper
                        labelText='Cama'
                        keySelect={`${watch('nroDiaFin')}-${watch('CampamentoId')}-${watch(
                          'HabitacionId',
                        )}`}
                        name='CamaId'
                        loadOptions={loadOptionsBed}
                        onChangeValue={getInformationBed}
                        value={{
                          value: watch('CamaId') || '',
                          label: watch('CamaCodigo') || '',
                        }}
                      />
                    </div>
                  </>
                )}

                <div className='col-sm-12 col-lg-2 ms-auto d-flex align-items-center justify-content-end'>
                  <Button
                    typeBtn='button'
                    label='Descargar'
                    onClick={handleExportXLS}
                    loading={isDownloadXLS}
                    disabled={isDownloadXLS}
                  />
                </div>
              </div>
            </form>
            <TotalComponent
              setDataGroup={setDataGroup}
              setIsReset={setIsReset}
              isReset={isReset}
              dataGroup={dataGroup}
            />

            <ButtonWrapper className={'sdx-white-bg'}>
              <Button
                label='Buscar'
                onClick={handleSubmit(onSubmit)}
                loading={searching}
                disabled={searching}
              />
              <Button label='Limpiar' onClick={handleClear} />
            </ButtonWrapper>
          </FormProvider>
        </div>

        {show && (
          <TableReportOccupancy2
            dataGroup={dataGroup}
            selectedOption={valueForm}
            searching={searching}
            setSearching={setSearching}
          />
        )}
      </KTCard>
    </>
  )
}

export {ReportOccupancy2}
